module.exports = __webpack_public_path__ + "static/media/Scheduler_Vacation.c54e0df4.svg";